import { TransferMethodType } from '../types/graphql'
import { gql, useApolloClient } from '@apollo/client'

// Need to pass in translation function t.
export const titleForTransferMethodType = (type: TransferMethodType, t: any) => {
    switch (type) {
        case TransferMethodType.BankAccount:
            return t('transfer_method_bank_account')
        case TransferMethodType.PaypalAccount:
            return t('transfer_method_paypal_account')
        case TransferMethodType.PrepaidCard:
            return t('transfer_method_prepaid_card')
        case TransferMethodType.VenmoAccount:
            return t('transfer_method_venmo_account')
    }
}

export const REMOVETRANSFERMETHOD = gql`
    mutation transferMethodRemove($id: ID!) {
        transferMethodRemove(id: $id) {
            user {
                id
            }
        }
    }
`
